import React, { useRef, useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';

import { ICON_SAVE, ICON_CANCEL } from '../../extras/icons';
import ButtonSpinner from '../../layout/ButtonSpinner';

//Redux
import { useDispatch, useSelector } from 'react-redux';
import { saveAudienceTypesAction, updateAudienceTypesAction } from '../../../actions/audienceTypesActions';
import { listAudienceCategoriesAction } from '../../../actions/audienceCategoriesActions';
import { listResultTypesAction } from '../../../actions/resultTypesActions';

import priorities from '../../../data/audiencePriorities';
import { AUDIENCIA_GROUP, IMPUTADO_GROUP } from '../../../data/resultTypeGroups';
//Función principal
const AudienceTypeForm = props => {
    //Tomo los props
    const { show, handleClose } = props;
    //Genero los refs
    const refDescription = useRef();
    //Datos iniciales
    const initialData = {
        descripcion: '',
        prioridad: '',
        tiempo: '',
        categoria: '',
        plazoMaximo: '',
        plazoMinimo: '',
        resultados: [],
        resultados_imputados: []
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const audienceTypesLoading = useSelector( state => state.audienceTypes.loadingSave );
    const errorSave = useSelector( state => state.audienceTypes.errorSave );
    const isEdit = useSelector( state => state.audienceTypes.isEdit );
    const audienceTypeSelected = useSelector( state => state.audienceTypes.audienceTypeSelected );
    const audienceCategories = useSelector( state => state.audienceCategories.audienceCategories );
    const resultTypes = useSelector( state => state.resultTypes.resultTypes );
    //Inicializo el state local
    const [ audienceType, setAudienceType ] = useState(initialData);
    //Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && audienceTypeSelected){
            setAudienceType({
                ...audienceTypeSelected,
                prioridad: audienceTypeSelected.prioridad ? audienceTypeSelected.prioridad.id : '',
                categoria: audienceTypeSelected.categoria ? audienceTypeSelected.categoria.id : '',
                resultados: audienceTypeSelected.resultadoList && audienceTypeSelected.resultadoList.length > 0 ? 
                    audienceTypeSelected.resultadoList.filter(r => r.tipo === AUDIENCIA_GROUP).map(type => ({ id: type.id, value: type.id, label: type.descripcion}))
                 : [],
                resultados_imputados: audienceTypeSelected.resultadoList && audienceTypeSelected.resultadoList.length > 0 ? 
                 audienceTypeSelected.resultadoList.filter(r => r.tipo === IMPUTADO_GROUP).map(type => ({ id: type.id, value: type.id, label: type.descripcion}))
              : []
            });
        }else{
            setAudienceType(initialData);
        }
    }, [isEdit, audienceTypeSelected, show])
    //Manejo de cambios
    const handleChange = e => {
        setAudienceType({
            ...audienceType,
            [e.target.name]: e.target.value
        })
    }
    //Manejo cambio del select
    const handleChangeResultados = (options, values, e) => {
        //Seteo los datos
        setAudienceType({
            ...values,
            [e.name]: options ? options.map(option => (
                {
                    id: option.value,
                    value: option.value,
                    label: option.label
                }
            )) : []
        })
    }
    //Manejo el guardado
    const handleSave = values => {
        //Armo el objeto de datos
        let data = {
            descripcion: values.descripcion,
            tiempo: values.tiempo,
            categoria: {
                id: values.categoria
            },
            prioridad: {
                id: values.prioridad
            },
            plazoMinimo: values.plazoMinimo,
            plazoMaximo: values.plazoMaximo,
            resultadoList: [
                ...audienceType.resultados,
                ...audienceType.resultados_imputados
            ],
            activo: 1
        }
        //Verifico si es edición o alta
        if(audienceType.id){
            //Agrego el ID a la data
            data = {
                id: audienceType.id,
                ...data
            }
            //Es edición
            dispatch( updateAudienceTypesAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( saveAudienceTypesAction(data, handleCloseForm) );
        }
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Me fijo si están cargadas las categorías
        if(!audienceCategories){
            dispatch( listAudienceCategoriesAction({
                search: 'activo:1',
                sort: 'descripcion:asc'
            }) );
        }
        //Me fijo si están los tipos de resultados
        if(!resultTypes){
            //Solo los de audiencia
            const params = {
                search: 'activo:1',
                tipo: AUDIENCIA_GROUP,
                sort: 'descripcion:asc'
            }
            //Hago la consulta
            dispatch( listResultTypesAction(params) );
        }
        //Pongo el foco en el primer campo
        refDescription.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setAudienceType(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        descripcion: yup.string().required(),
        prioridad: yup.number().required(),
        tiempo: yup.number().required(),
        categoria: yup.number().required(),
        plazoMaximo: yup.number().required(),
        plazoMaximo: yup.number().required(),
        resultados: yup.array().nullable()
    });
    //Renderizo
    return (
        <Modal 
            show={show} 
            onHide={handleCloseForm} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Audiencia Tipo&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...audienceType }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-12">
                                    <label htmlFor="descripcion">Descripción</label>
                                    <Form.Control
                                        id="descripcion"
                                        className="form-control" 
                                        autoFocus 
                                        name="descripcion" 
                                        type="text" 
                                        value={ values.descripcion }
                                        onChange={handleChange}
                                        ref={refDescription}
                                        isInvalid={!!errors.descripcion}
                                        disabled={ audienceTypesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.descripcion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <label htmlFor="prioridad">Prioridad</label>
                                    <Form.Control
                                        as="select"
                                        id="prioridad"
                                        className="form-control"  
                                        name="prioridad" 
                                        type="text" 
                                        value={ values.prioridad }
                                        onChange={handleChange}
                                        isInvalid={!!errors.prioridad}
                                        disabled={ audienceTypesLoading }
                                    >
                                        <option value="">Seleccione la Prioridad</option>
                                        {
                                            priorities.map(priority => (
                                                <option value={priority.id} key={`atp${priority.id}`}>
                                                    { priority.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.prioridad }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <label htmlFor="tiempo">Tiempo (en min.)</label>
                                    <Form.Control
                                        id="tiempo"
                                        className="form-control" 
                                        autoFocus 
                                        name="tiempo" 
                                        type="text" 
                                        value={ values.tiempo }
                                        onChange={handleChange}
                                        isInvalid={!!errors.tiempo}
                                        disabled={ audienceTypesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.tiempo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <label htmlFor="plazoMinimo">Plazo mínimo</label>
                                    <Form.Control
                                        id="plazoMinimo"
                                        className="form-control" 
                                        name="plazoMinimo" 
                                        type="text" 
                                        value={ values.plazoMinimo }
                                        onChange={handleChange}
                                        isInvalid={!!errors.plazoMinimo}
                                        disabled={ audienceTypesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.plazoMinimo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <label htmlFor="tiempo">Plazo máximo</label>
                                    <Form.Control
                                        id="plazoMaximo"
                                        className="form-control" 
                                        name="plazoMaximo" 
                                        type="text" 
                                        value={ values.plazoMaximo }
                                        onChange={handleChange}
                                        isInvalid={!!errors.plazoMaximo}
                                        disabled={ audienceTypesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.plazoMaximo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="categoria">Categoría</label>
                                    <Form.Control
                                        as="select"
                                        id="categoria"
                                        className="form-control"  
                                        name="categoria" 
                                        type="text" 
                                        value={ values.categoria }
                                        onChange={handleChange}
                                        isInvalid={!!errors.categoria}
                                        disabled={ audienceTypesLoading }
                                    >
                                        <option value="">Seleccione la Categoría</option>
                                        {
                                            audienceCategories ? (
                                                audienceCategories.map(audienceCategory => (
                                                    audienceCategory.grupo !== null ? (
                                                        <option value={audienceCategory.id} key={`atc${audienceCategory.id}`}>
                                                            { audienceCategory.descripcion }
                                                        </option>    
                                                    ) : null
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.categoria }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="resultados">Resultados Audiencias</label>
                                    <Select
                                        name="resultados"
                                        onChange={(options, e) => handleChangeResultados(options, values, e)}
                                        isMulti
                                        noOptionsMessage={() => ("No se encontraron datos")}
                                        placeholder="Seleccione"
                                        value={audienceType.resultados}
                                        options={
                                            resultTypes ? (
                                                resultTypes.filter(result => result.tipo === AUDIENCIA_GROUP).map(resultType => (
                                                    {
                                                        value: resultType.id,
                                                        label: resultType.descripcion
                                                    }
                                                ))
                                            ) : []
                                        }
                                    />
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="resultados_imputados">Resultados Imputados</label>
                                    <Select
                                        name="resultados_imputados"
                                        onChange={(options, e) => handleChangeResultados(options, values, e)}
                                        isMulti
                                        noOptionsMessage={() => ("No se encontraron datos")}
                                        placeholder="Seleccione"
                                        value={audienceType.resultados_imputados}
                                        options={
                                            resultTypes ? (
                                                resultTypes.filter(result => result.tipo === IMPUTADO_GROUP).map(resultType => (
                                                    {
                                                        value: resultType.id,
                                                        label: resultType.descripcion
                                                    }
                                                ))
                                            ) : []
                                        }
                                    />
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                audienceTypesLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ audienceTypesLoading }>
                                        <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ audienceTypesLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default AudienceTypeForm;